export type TestPanel = {
  key: string;            // t.ex. 'google-gemini'
  titleKey: string;       // i18n-nyckel
  descriptionKey: string; // i18n-nyckel
  path: string;           // React route
};

export const TEST_PANELS: TestPanel[] = [
  {
    key: 'google-gemini',
    titleKey: 'Google Gemini 1.5 Pro',
    descriptionKey: 'Vertex AI med 1M tokens context window via Service Account',
    path: '/testlab/google-gemini'
  }
  // fler paneler läggs till här senare
];
